var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPoint = function SvgPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m6 15-1.03-.92C1.677 11.149 0 8.543 0 6.104 0 2.64 2.657 0 6 0s6 2.64 6 6.103c0 2.44-1.678 5.045-4.97 7.978zm4-8.897C10 3.748 8.24 2 6 2S2 3.748 2 6.103c0 1.67 1.298 3.744 4 6.214 2.702-2.47 4-4.544 4-6.214M8 6a2 2 0 1 0-4 0 2 2 0 0 0 4 0",
    clipRule: "evenodd"
  })));
};
export default SvgPoint;